
const config = {
  backendUrl: "https://api.shop-connect.pipelabs.dev", // 'https://69f55422b1d8.ngrok.io',
  storeId: '3b07f4f4-2fb8-46a1-9c45-d3cb00e400d2', //'67c88416-1484-4c8f-a80a-321f03a0716e', //'3b07f4f4-2fb8-46a1-9c45-d3cb00e400d2',
  bucket: process.env.BUCKET || 'https://storage.googleapis.com/gant-dev-image-sync',
  imageProxy: (res, url) => {
    return `https://api.shop-connect.pipelabs.dev/images?size=${res ? res : 500}&url=${url}`
  }
};

export default config;
